import { object, array, string } from '@gogame/schemas';
import {
  COLUMN_POSTBACK_DATE,
  COLUMN_APPLICATION_NAME,
  COLUMN_AFFILIATE_NAME,
  COLUMN_CAMPAIGN_ID,
  COLUMN_CAMPAIGN_NAME,
  COLUMN_REG_ACTION_ID,
  COLUMN_AD_CLICK_ID,
  COLUMN_EVENT_TIME,
  COLUMN_EVENT_NAME,
  COLUMN_POSTBACK_URL,
  COLUMN_REGISTRATION_DATE,
} from '../constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_POSTBACK_DATE,
    COLUMN_APPLICATION_NAME,
    COLUMN_AFFILIATE_NAME,
    COLUMN_CAMPAIGN_ID,
    COLUMN_CAMPAIGN_NAME,
    COLUMN_REG_ACTION_ID,
    COLUMN_REGISTRATION_DATE,
    COLUMN_AD_CLICK_ID,
    COLUMN_EVENT_TIME,
    COLUMN_EVENT_NAME,
    COLUMN_POSTBACK_URL,
  ]),
  collapsed: array(string()).default([]),
});
